import { GalleryService } from '../gallery.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  GalleryCollection,
  GALLERY_COLLECTIONS,
  GALLERY_CATEGORIES,
  GalleryRecordMetadata
} from 'shared';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-gallery-collection-page',
  templateUrl: './gallery-collection-page.component.html',
  styleUrls: ['./gallery-collection-page.component.scss']
})
export class GalleryCollectionPageComponent implements OnInit {
  collection: GalleryCollection = {} as GalleryCollection;
  collectionId = '';
  CATEGORIES = GALLERY_CATEGORIES;
  categoryThumbnails = new Map<string, string>();
  isBrowser = false;
  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private galleryService: GalleryService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  async ngOnInit(): Promise<void> {
    if (this.isBrowser) {
      await this.galleryService.fetchMetadata();
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.collectionId = this.activeRoute.snapshot.paramMap.get('collection');
      this.collection = GALLERY_COLLECTIONS[decodeURI(this.collectionId)];
      // fetch gallery thumbnails
      const meta: GalleryRecordMetadata = this.galleryService.galleryRecordMetadata;
      this.collection.categories.forEach((category) => {
        const thumbs = meta.galleryCategoryData[category]?.thumbnailURLs ?? [];
        const thumb =
          thumbs.length > 0
            ? thumbs[Math.floor(thumbs.length * Math.random())]
            : 'assets/images/missing_photo.jpg';
        this.categoryThumbnails.set(category, thumb);
      });
    }
  }
}
